import { Text } from "@backstage/ui";
import {
	AVD_LIFECYCLE_DESCRIPTOR,
	BUNDLE_HOLD_LIMITS,
} from "@internal/backstage-plugin-avd-common";

import type { BundlePageDescriptor } from "../bundle/bundleDescriptors";

import { MY_AVD_HERO, MY_AVD_SETUP_PATH } from "./avdEntitlement";

/** My AVD's part of the bundle page: its copy. The wording of its states is `myDesktop.tsx`. */
export const avdPageDescriptor: BundlePageDescriptor = {
	bundleType: "avd",
	noun: "desktop",
	hero: MY_AVD_HERO,
	yours: { eyebrow: "Status", title: "Your desktop" },
	empty: {
		title: "No desktop",
		body: "You don't have a desktop yet. Setting one up takes about 10–15 minutes, and you'll get a notification when it's ready.",
		setupLabel: "Set up my desktop",
	},
	setup: {
		eyebrow: "Set up",
		title: "First time here, or need a repair?",
		body: "Setting up a desktop takes about 10–15 minutes, and you'll get a notification when it's ready. Re-running this repairs your existing desktop — it won't wipe your files.",
		label: "Set up or repair",
		href: MY_AVD_SETUP_PATH,
	},
	goodToKnow: {
		title: "What is this, and what is it for?",
		body: (
			<>
				<Text as="p">
					An <strong>AVD</strong> — Azure Virtual Desktop — is a personal Windows 11
					computer in Microsoft's cloud, reached through a browser and kept exactly as you
					left it between sessions. It's yours alone and disposable: somewhere to install
					a package, try a tool or run an experiment without touching your Implement
					laptop or network — remove it when you're done and set up a fresh one whenever
					you need one.
				</Text>
				<ul>
					<li>
						It's deliberately kept apart from Implement's internal systems, so it isn't
						the place for client-confidential material.
					</li>
					<li>
						It shuts down by itself at 22:00 each evening to keep the cost of an idle
						desktop near zero, and starts again the next time you connect. Saved files
						survive; unsaved work in an open app does not.
					</li>
					<li>The cost is billed to a project number you give when you set it up.</li>
					<li>
						A desktop nobody has connected to for{" "}
						{AVD_LIFECYCLE_DESCRIPTOR.inactivityWindowDays} days is deleted, after one
						warning. Nothing is backed up. Away for a while? A hold keeps it for up to{" "}
						{BUNDLE_HOLD_LIMITS.selfMaxDays} days.
					</li>
					<li>
						Removing it permanently deletes the machine and every file on it, and cannot
						be undone.
					</li>
				</ul>
			</>
		),
	},
};
